import { BannerKey, BannerPosition } from 'features/banner/model/banner';

import { GtmEvent } from '../../enum/gtm-event';
import { GtmAction } from '../gtm-action';
import { GtmVariableKey } from '../gtm-variable-key';

export type BannerActionClickedGtmActionPayload = {
    /** Which action of the banner was clicked, e.g. `upgrade_plan` */
    [GtmVariableKey.name]: string;
    [GtmVariableKey.key]: BannerKey;
    [GtmVariableKey.position]: BannerPosition;
};

/** A banner's call-to-action was clicked; `pathname` is added by `useSendGTMAction` like for every event. */
export class BannerActionClickedGtmAction implements GtmAction {
    event = GtmEvent.banner_action_clicked;

    constructor(public payload: BannerActionClickedGtmActionPayload) {}
}
